import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    compilerOptions: {
      // register any non-vue custom elements we can use inside this app
      isCustomElement: (tag) => ["g-map-2", "g-marker", "ada-toggler", "fieldgroup" ].includes(tag),
    },    
    props: [
      'el'
    ],
    data(){
      return {
        foundLocations: [],

        // localized data
        googleMapsAPIKey: '',

        // app data
        searchType: 'geolocation', // geolocation|zip - how should the users latitude/longitude be determined? 
        zip: null,
        radius: 10,
        filters: [],

        // data to manage the app state
        searchIsDirty : false,
        latitude: null,
        longitude: null,
        loading: false,
      }
    },
    mounted(){
      this.googleMapsAPIKey = this.el.dataset.mapKey
    },
    computed: {
      currentDay() {
        return new Date().toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
      }
    },
    methods: {
      handleFormSubmission(closeFilters, resetFilters) {
        if(closeFilters){
          // document.querySelector("[for='filters-content']")._onTogglerClick()
        }

        if(resetFilters){
          this.filters = []
        }

        if(this.searchType == 'geolocation'){
          this.setLatLongByNear()
        } else {
          this.sortAndFilter()
        }

      },
      // sets latitude/longitude by the users geolocation, runs the search
      setLatLongByNear(){
        if(this.latitude && this.longitude){
          this.sortAndFilter()
          return            
        }

        this.loading = true

        if(navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(pos => {
            this.loading = false
            this.latitude = pos.coords.latitude
            this.longitude = pos.coords.longitude
            this.sortAndFilter()
          }, err => {
            this.loading = false
            switch (err.code) {
              case err.PERMISSION_DENIED:
                alert("User denied the request for Geolocation.")
                break
              case err.POSITION_UNAVAILABLE:
                alert("Location information is unavailable.")
                break
              case err.TIMEOUT:
                alert("The request to get user location timed out.")
                break
              case err.UNKNOWN_ERROR:
                alert("An unknown error occurred.")
                break
            }
          })
        } else {
          this.loading = false
          alert("Geolocation is not supported by this browser")
        }
      },
      // primary ajax handler
      // returns foundLocations
      sortAndFilter(){
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: 'fetch_biggby_locations',
          zip_code: this.zip,
          latitude: this.latitude,
          longitude: this.longitude,
          radius: this.radius,
          filters : this.filters
        }, success => {
          this.loading = false
          if(success?.success){
            this.foundLocations = success.data.posts
            this.searchIsDirty = true
          } else {
            alert("Unexpected result. Please try again later.")
          }
        }, error => {
          this.loading = false
          alert("Something went wrong. Please try again later.")
        })
      },
      // reset lat/lng on search type change
      onSearchTypeChange(){
        this.latitude = null
        this.longitude = null
      },

    }
  }

  function initApp(){
    const els = document.querySelectorAll('.locations-map--app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()
}